import { RemoteTaker } from "../../../../data/usecases/taker/remote-taker";
import { Taker } from "../../../../domain/models/taker";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteTaker = (): Taker =>
  new RemoteTaker("/takers", makeAxiosHttpClient());
